import React, { FC, memo, ReactNode, useCallback } from 'react';

import './content.scss';

import Logo from './logo.svg';

interface ContentProps {
  className?: string;
  children: ReactNode;
  isInner?: boolean;
}

const Content: FC<ContentProps> = memo(({className, isInner, children}) => {
  const handleClick = useCallback(
    () => {
      window.location.reload();
    },
    []
  );

  return (
    <div className={`content ${className}`}>
      {isInner &&
        <button type="button" className="content__logo" onClick={handleClick}><img src={Logo} alt="mail.ru" /></button>
      }
      {children}
    </div>
  );
});

export default Content;
